import React from "react";
import { useGetIntensityUrl } from "hooks";
import { CommonQuicksightDashboard } from "../components";

export const IntensityTab = () => {
  const { data: intensityResponse, isLoading: isLoadingIntensity } = useGetIntensityUrl();

  return (
    <CommonQuicksightDashboard
      title="Intensity"
      embedUrl={intensityResponse?.embedUrl ?? ""}
      isLoading={isLoadingIntensity}
    />
  );
};
